import React from 'react'

import { OrthopedicAndEmergency } from './components/OrthopedicAndEmergency'
import { ServicesIntroduction } from './components/ServicesIntroduction'
import { SurgeryAndAmbulant } from './components/SurgeryAndAmbulant'

interface ServicesProps {
    className?: string
}

export const Services: React.FC<ServicesProps> = ({ className }) => {
    return (
        <div className={`${className} flex flex-col w-full justify-center items-center`}>
            <ServicesIntroduction className="max-w-container-s" />
            <SurgeryAndAmbulant className="max-w-container-s" />
            <OrthopedicAndEmergency className="max-w-container-s" />
        </div>
    )
}
